// DO NOT MODIFY! THIS FILE IS AUTOGENERATED BY generate-endpoint-spec.util.ts

import { RequestHandler } from 'express';

export const TSpecRoute_reorderLibraryDocs = () => "/library/docs/reorder";

export type TSpecHandler_reorderLibraryDocs = RequestHandler<TSpecPathReorderLibraryDocs, any, TSpecBodyReorderLibraryDocs, TSpecQueryReorderLibraryDocs, {}>;

export interface TSpecPathReorderLibraryDocs {  }

export interface TSpecBodyReorderLibraryDocs {
  docs: {
    libraryDocId: string;
    orderIndex: number;
  }[];
}

export interface TSpecQueryReorderLibraryDocs {
  AppVersion?: string;
  AppUser?: string;
}
